module.exports = __webpack_public_path__ + "static/media/assignments-active.1dfdf9d0.svg";